// generated by the plop

import { PaginatorModel, PROGRESS_STATUSES } from 'symbols';
import { OrderModel, OrdersCountModel, OrderStatusExpectBackend } from '../../symbols';

export interface OrderListStateModel {
  orderList: PaginatorModel<OrderModel>;
  orderListInteractive: PaginatorModel<OrderModel>;
  loadOrderListStatus: PROGRESS_STATUSES;
  lastOpenedDocId: string;
  orderStatusList: OrderStatusExpectBackend[];
  scrollPosition: number;
  ordersCount: OrdersCountModel;
}

export const ORDER_LIST_STATE_DEFAULT: OrderListStateModel = {
  orderList: {
    data: [],
    links: null,
    meta: null
  },
  orderListInteractive: {
    data: [],
    links: null,
    meta: null
  },
  loadOrderListStatus: PROGRESS_STATUSES.NOT_INITIALIZED,
  lastOpenedDocId: null,
  orderStatusList: [],
  scrollPosition: 0,
  ordersCount: {
    notConfirmedCount: 0,
    acceptedCount: 0,
    issuedCount: 0
  }
};
